import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles, minResolution } from 'util/helpers';

import icPinHoshinoyaPC1x from 'assets/images/PC/@1x/ic_pin_hoshinoya.png';
import icPinHoshinoyaPC2x from 'assets/images/PC/@2x/ic_pin_hoshinoya@2x.png';
import icPinHoshinoyaSP2x from 'assets/images/SP/@2x/ic_pin_hoshinoya@2x.png';
import icPinHoshinoyaSP3x from 'assets/images/SP/@3x/ic_pin_hoshinoya@3x.png';
import icPinKaiPC1x from 'assets/images/PC/@1x/ic_pin_kai.png';
import icPinKaiPC2x from 'assets/images/PC/@2x/ic_pin_kai@2x.png';
import icPinKaiSP2x from 'assets/images/SP/@2x/ic_pin_kai@2x.png';
import icPinKaiSP3x from 'assets/images/SP/@3x/ic_pin_kai@3x.png';
import icPinRisonarePC1x from 'assets/images/PC/@1x/ic_pin_risonare.png';
import icPinRisonarePC2x from 'assets/images/PC/@2x/ic_pin_risonare@2x.png';
import icPinRisonareSP2x from 'assets/images/SP/@2x/ic_pin_risonare@2x.png';
import icPinRisonareSP3x from 'assets/images/SP/@3x/ic_pin_risonare@3x.png';
import icPinOmoPC1x from 'assets/images/PC/@1x/ic_pin_omo.png';
import icPinOmoPC2x from 'assets/images/PC/@2x/ic_pin_omo@2x.png';
import icPinOmoSP2x from 'assets/images/SP/@2x/ic_pin_omo@2x.png';
import icPinOmoSP3x from 'assets/images/SP/@3x/ic_pin_omo@3x.png';
import icPinBebPC1x from 'assets/images/PC/@1x/ic_pin_beb.png';
import icPinBebPC2x from 'assets/images/PC/@2x/ic_pin_beb@2x.png';
import icPinBebSP2x from 'assets/images/SP/@2x/ic_pin_beb@2x.png';
import icPinBebSP3x from 'assets/images/SP/@3x/ic_pin_beb@3x.png';
import icPinOtherPC1x from 'assets/images/PC/@1x/ic_pin_other.png';
import icPinOtherPC2x from 'assets/images/PC/@2x/ic_pin_other@2x.png';
import icPinOtherSP2x from 'assets/images/SP/@2x/ic_pin_other@2x.png';
import icPinOtherSP3x from 'assets/images/SP/@3x/ic_pin_other@3x.png';

const Pin = ({ brand, className, style }) => (
  <div className={`${className} brand-${brand}`} style={style} />
);

const commonStyle = css`
  background-position: 50%;
  z-index: 0;
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  width: 34px;
  height: 43px;
  background-size: 56px;

  &.brand-hoshinoya {
    background-image: url('${icPinHoshinoyaPC1x}');

    ${minResolution(2)`
      background-image: url('${icPinHoshinoyaPC2x}');
    `}
  }

  &.brand-kai {
    background-image: url('${icPinKaiPC1x}');

    ${minResolution(2)`
      background-image: url('${icPinKaiPC2x}');
    `}
  }

  &.brand-risonare {
    background-image: url('${icPinRisonarePC1x}');

    ${minResolution(2)`
      background-image: url('${icPinRisonarePC2x}');
    `}
  }

  &.brand-omo {
    background-image: url('${icPinOmoPC1x}');

    ${minResolution(2)`
      background-image: url('${icPinOmoPC2x}');
    `}
  }

  &.brand-beb {
    background-image: url('${icPinBebPC1x}');

    ${minResolution(2)`
      background-image: url('${icPinBebPC2x}');
    `}
  }

  &.brand-other {
    background-image: url('${icPinOtherPC1x}');

    ${minResolution(2)`
      background-image: url('${icPinOtherPC2x}');
    `}
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  width: 28px;
  height: 28px;
  background-size: 28px;

  &.brand-hoshinoya {
    background-image: url('${icPinHoshinoyaSP2x}');

    ${minResolution(3)`
      background-image: url('${icPinHoshinoyaSP3x}');
    `}
  }

  &.brand-kai {
    background-image: url('${icPinKaiSP2x}');

    ${minResolution(3)`
      background-image: url('${icPinKaiSP3x}');
    `}
  }

  &.brand-risonare {
    background-image: url('${icPinRisonareSP2x}');

    ${minResolution(3)`
      background-image: url('${icPinRisonareSP3x}');
    `}
  }

  &.brand-omo {
    background-image: url('${icPinOmoSP2x}');

    ${minResolution(3)`
      background-image: url('${icPinOmoSP3x}');
    `}
  }

  &.brand-beb {
    background-image: url('${icPinBebSP2x}');

    ${minResolution(3)`
      background-image: url('${icPinBebSP3x}');
    `}
  }

  &.brand-other {
    background-image: url('${icPinOtherSP2x}');

    ${minResolution(3)`
      background-image: url('${icPinOtherSP3x}');
    `}
  }
`;

export default applyStyles(Pin)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/Home/components/Pin.js